import { enableProdMode, importProvidersFrom } from '@angular/core';

import { DatePipe, registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr'; // For French (DD/MM/YYYY)
import { LOCALE_ID } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { AIS140ApiReqLogsRoutingModule } from './app/ais140-api-req-logs/ais140-api-req-logs-routing.module';
import { AIS140ApiResLogsRoutingModule } from './app/ais140-api-res-logs/ais140-api-res-logs-routing.module';
import { AIS140TicketDetailsRoutingModule } from './app/ais140-ticket-details/ais140-ticket-details-routing.module';
import { AIS140TicketListRoutingModule } from './app/ais140-ticket-list/ais140-ticket-list-routing.module';
import { AIS140TmlApiLogsRoutingModule } from './app/ais140-tml-api-logs/ais140-tml-api-logs-routing.module';
import { routes } from './app/app-routes';
import { AppComponent } from './app/app.component';
import { DateFormat, MY_DATE_FORMATS } from './app/date-format';
import { DealerFotaApprovedFilesPageRoutingModule } from './app/dealer-fota-approved-files/dealer-fota-approved-files-routing.module';
import { dealerFotaPageRoutingModule } from './app/dealer-fota/dealer-fota-routing.module';
import { DealerMasterRoutingModule } from './app/dealer-master/dealer-master-routing.module';
import { DeviceDashboardPageRoutingModule } from './app/device-dashboard-page/device-dashboard-page-routing.module';
import { DeviceDetailsPageRoutingModule } from './app/device-details-page/device-details-page-routing.module';
import { DeviceModelDetailsRoutingModule } from './app/device-model-details/device-model-details-routing.module';
import { DeviceModelListRoutingModule } from './app/device-model-list/device-model-list-routing.module';
import { DeviceStateConfigPageModule } from './app/device-state-config/device-state-config.module';
import { DeviceSystemActivityLogPageModule } from './app/device-system-activity-log/device-system-activity-log.module';
import { DeviceVinConfigPageModule } from './app/device-vin-config/device-vin-config.module';
import { DispatchDeviceAddRoutingModule } from './app/dispatch-device-add/dispatch-device-add-routing.module';
import { DispatchDeviceListRoutingModule } from './app/dispatch-device-list/dispatch-device-list-routing.module';
import { FotaBatchDetailsRoutingModule } from './app/fota-batch-details/fota-batch-details-routing.module';
import { FotaBatchListRoutingModule } from './app/fota-batch-list/fota-batch-list-routing.module';
import { FotaBatchReportsRoutingModule } from './app/fota-batch-reports/fota-batch-reports-routing.module';
import { GovtServersAddPageRoutingModule } from './app/govt-servers-add-page/govt-servers-add-page-routing.module';
import { GovtServersPageRoutingModule } from './app/govt-servers-page/govt-servers-page-routing.module';
import { GroupManagementPageRoutingModule } from './app/group-management/group-management-routing.module';
import { HttpTokenInterceptorService } from './app/http-token-interceptor.service';
import { InstitutionalSalesPageRoutingModule } from './app/institutional-sales/institutional-sales-routing';
import { LoginPageRoutingModule } from './app/login-page/login-page-routing.module';
import { DeviceManualFotaRoutingModule } from './app/manual-fota/manual-fota-routing.module';
import { DeviceManualOtaRoutingModule } from './app/manual-ota/manual-ota-routing.module';
import { OtaBatchCreateRoutingModule } from './app/ota-batch-create/ota-batch-create-routing.module';
import { OtaBatchListRoutingModule } from './app/ota-batch-list/ota-batch-list-routing.module';
import { OtaBatchReportsRoutingModule } from './app/ota-batch-reports/ota-batch-reports-routing.module';
import { OtaBatchViewRoutingModule } from './app/ota-batch-view/ota-batch-view-routing.module';
import { OtaMasterRoutingModule } from './app/ota-master/ota-master-routing.module';
import { ProfilePageRoutingModule } from './app/profile-page/profile-page-routing.module';
import { RoleManagementRoutingModule } from './app/role-management/role-management-routing.module';
import { SimDataDetailsRoutingModule } from './app/sim-data-details/sim-data-details-routing.module';
import { TicketDashboardPageRoutingModule } from './app/ticket-dashboard-page/ticket-dashboard-page-routing.module';
import { TicketAssignmentMasterRoutingModule } from './app/ticket-assignment-master/ticket-assignment-master-routing.module';
import { UserManagementRoutingModule } from './app/user-management/user-management-routing.module';
import { environment } from './environments/environment';

registerLocaleData(localeFr);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      // routing module import
      // Page Category: Login Page
      LoginPageRoutingModule,
      // Navigation Bar Category: Dashboard
      // Page Category: Device Dashboard
      DeviceDashboardPageRoutingModule,
      DeviceDetailsPageRoutingModule,
      // Page Category: My AIS 140 Ticket Dashboard
      TicketDashboardPageRoutingModule,
      TicketAssignmentMasterRoutingModule,
      // Navigation Bar Category: Device Utility
      // Page Category: My AIS 140 Tickets
      AIS140TicketListRoutingModule,
      AIS140TicketDetailsRoutingModule,
      InstitutionalSalesPageRoutingModule,
      DealerMasterRoutingModule,
      // Page Category: Government Server
      GovtServersPageRoutingModule,
      GovtServersAddPageRoutingModule,
      // Page Category: FOTA
      FotaBatchListRoutingModule,
      FotaBatchDetailsRoutingModule,
      DeviceManualFotaRoutingModule,
      // Page Category: OTA
      OtaBatchListRoutingModule,
      OtaBatchCreateRoutingModule,
      OtaBatchViewRoutingModule,
      OtaMasterRoutingModule,
      DeviceManualOtaRoutingModule,
      // Page Category: Device Model
      DeviceModelListRoutingModule,
      DeviceModelDetailsRoutingModule,
      // Page Category: Dealer FOTA
      dealerFotaPageRoutingModule,
      DealerFotaApprovedFilesPageRoutingModule,
      // Page Category: Add Dispatch Devices
      DispatchDeviceListRoutingModule,
      DispatchDeviceAddRoutingModule,
      // Navigation Bar Category: Reports
      // Page Category: AIS140 Ticket TML Request Logs
      AIS140ApiReqLogsRoutingModule,
      // Page Category: AIS140 Ticket AEPL Response Logs
      AIS140ApiResLogsRoutingModule,
      // Page Category: AIS140 Ticket Status Update Logs
      AIS140TmlApiLogsRoutingModule,
      DeviceSystemActivityLogPageModule,
      DeviceStateConfigPageModule,
      DeviceVinConfigPageModule,
      // Page Category: Vehicle EOL
      // VehicleEolBatchRoutingModule,
      // VehicleEolDataRoutingModule,
      // Page Category: SIM Data Details
      SimDataDetailsRoutingModule,
      // Navigation Bar Category: User
      // Page Category: User Management
      UserManagementRoutingModule,
      // Page Category: User Role
      RoleManagementRoutingModule,
      GroupManagementPageRoutingModule,
      // Page Category: User Permission
      // Navigation Bar Category: Profile
      // Page Category: Profile
      ProfilePageRoutingModule,
      // DispatchDeviceAddRoutingModule,
      FotaBatchReportsRoutingModule,
      OtaBatchReportsRoutingModule
    ),
    { provide: LOCALE_ID, useValue: 'en-GB' }, // ✅ Ensures DD/MM/YYYY format globally
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: DateFormat },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptorService,
      multi: true,
    },
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes),
  ],
}).catch((err) => console.error(err));
